import { all, call } from "typed-redux-saga/macro";
import { userSagas } from "./user/user.saga";
import { dataSagas } from "./data/data.saga";
import { serviceSagas } from "./service/service.saga";

export function* rootSaga() {
  yield* all([call(userSagas), call(dataSagas), call(serviceSagas)]);
}
